<template>
  <div id="compreSportsMeet_schedule" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
        :manualRefresh="selectOpt_manualRefresh"
      ></marathon_select_opt>
    </div>
    <template v-if="themeItem && matchList && matchList.length > 0">
      <multipleChoiceShare_fixedBtn
        :model="multipleChoiceShareFixedBtn_model"
        :state="multipleChoiceShareFixedBtn_state"
        :modeType="multipleChoiceShareFixedBtn_modeType"
        :smallBtnArr="smallBtnArr"
        @changeModelEvent="changeModelEventHandler"
        @clickSmallBtnEvent="clickSmallBtnEventHandler"
        @clickFixedBtnEvent="clickFixedBtnEventHandler"
        :isShow="!noData"
      ></multipleChoiceShare_fixedBtn>
    </template>
    <div
      class="teamTable"
      :class="
        multipleChoiceShareFixedBtn_model === 'circular'
          ? 'multipleChoiceShare_fixedBtn_isCircular'
          : ''
      "
    >
      <div class="tableScrollArea" ref="tableParentDom">
        <div class="match_label_fixed" v-show="curMatchLabelFixedIcon">
          <div class="match_label">
            <span class="label_textArea">
              <span class="labelIcon">
                <img
                  :src="
                    currSid === 'ASG2026'
                      ? `/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/ASG2026/${currBigSports.icon}.png`
                      : `/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/sportsIcon/${currBigSports.icon}.png`
                  "
                />
              </span>
              <span
                :class="[
                  currBigSports.label && currBigSports.label.length === 2
                    ? 'letterSpa'
                    : '',
                ]"
                v-text="currBigSports.label"
              ></span>
            </span>
          </div>
        </div>
        <div :class="scrollDomClassName">
          <schedule_group_matchList
            v-for="item in matchList"
            :currCid="currCid"
            :currSid="currSid"
            :key="item.icon"
            :currThemeObj="currThemeObj"
            :data="item"
            :pbPx="matchItemPbpx"
            :matchListType="'player'"
          >
            <template v-slot:matchList>
              <schedulePhase_match_list
                :currCid="currCid"
                :currSid="currSid"
                :currThemeObj="currThemeObj"
                :data="item.list"
                :detailPathName="''"
                :chooseState="multipleChoiceShareFixedBtn_state"
                :localStorageName="
                  multipleChoiceShareFixedBtn_modeType &&
                  multipleChoiceShareFixedBtn_modeType.localStorageName
                    ? multipleChoiceShareFixedBtn_modeType.localStorageName
                    : ''
                "
                :localStorageSaveDate="currStageMatchDate"
                @changeChooseNumEvent="changeChooseNumEventHandler"
              />
            </template>
          </schedule_group_matchList>
        </div>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <p class="noDataClass" v-show="noData">暂无数据</p>
      </div>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
    <complex_multipleChoiceShare_dialog
      v-if="dialogItem && dialogItem.isDialogFlag"
      :currThemeObj="currThemeObj"
      :axiosBaseUrl="axiosBaseUrl"
      :platfromMenu_currGroup="currGroup"
      :currCid="currCid"
      :currSid="currSid"
      :dialogItem="dialogItem"
      :themeItem="themeItem"
      :localStorageChooseList="localStorageChooseList"
      :multipleChoiceShareFixedBtn_modeType="
        multipleChoiceShareFixedBtn_modeType
      "
      :curTimeZoneItem="curTimeZoneItem"
      @dialogCancelEvent="clickSmallBtnEventHandler"
      @dialogOkEvent="dialogOkEventHandler"
      @shareDoneEvent="shareDoneEventHandler"
    >
      <template v-slot:checkList>
        <schedulePhase_match_list
          :currCid="currCid"
          :currSid="currSid"
          :currThemeObj="currThemeObj"
          :data="localStorageChooseList"
          :detailPathName="''"
          :chooseState="multipleChoiceShareFixedBtn_state"
          :localStorageName="
            multipleChoiceShareFixedBtn_modeType &&
            multipleChoiceShareFixedBtn_modeType.localStorageName
              ? multipleChoiceShareFixedBtn_modeType.localStorageName
              : ''
          "
          :localStorageSaveDate="currStageMatchDate"
          @changeChooseNumEvent="changeChooseNumEventHandler"
        />
      </template>
    </complex_multipleChoiceShare_dialog>
  </div>
</template>

<script>
import {
  https_eventPhase_list,
  https_select_dateBigSports,
  https_sportsList_eventList,
} from '@api/platfrom_compreSportsMeet_api'
import BackTop from '@components/base/backTop.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'

import schedule_group_matchList from '@components/platfromBase/compreSportsMeet/schedule_group_matchList.vue'
import schedulePhase_match_list from '@components/platfromBase/compreSportsMeet/schedulePhase_match_list.vue'
import multipleChoiceShare_fixedBtn from '@components/platfromBase/compreSportsMeet/multipleChoiceShare_fixedBtn.vue'
import complex_multipleChoiceShare_dialog from '@components/platfromBase/compreSportsMeet/complex_multipleChoiceShare_dialog.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import multipleChoiceShare_data_mixin from '@mixins/multipleChoiceShare_data'

export default {
  name: 'compreSportsMeet_schedule',
  components: {
    marathon_select_opt,
    schedule_group_matchList,
    BackTop,
    multipleChoiceShare_fixedBtn,
    complex_multipleChoiceShare_dialog,
    schedulePhase_match_list,
  },
  mixins: [cup_base_data_mixin, multipleChoiceShare_data_mixin],
  props: {
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    bigSportsList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      isScrollBottom: false,
      firstPageIsScrollBottom: false,
      scrollDomClassName: 'scrollDomContain',
      scrollDomById: 'containerFull_body',
      loading: false,
      curMatchLabelFixedIcon: null,
      matchItemPbpx: 0,
      matchLabelArr: [],
      matchList: null,
      matchTotal: 0,
      currStageMatchDate: '',
      currStageBigSports: '',
      currStageSportEvents: '',
      // selectAllObj: {
      //   value: 'all',
      //   name: '全部',
      // },
      bigSportsArr: [],
      sportEventsArr: [], //分项数组
      selectOptData_origin: {
        configArr: [
          {
            type: 'bigSports',
            title: '项目',
            origin_keyVal: ['value', 'name'],
            dataName: 'bigSportsArr',
            selectIndex: 0,
            isFilterable: true,
          },
          {
            type: 'sportEvents',
            title: '分项',
            origin_keyVal: ['value', 'name'],
            dataName: 'sportEventsArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      selectOptData: null,
      showBackTop: false,
      multipleChoiceShareFixedBtn_modeType: {
        btnName: '项目阶段',
        localStorageName: 'mixtmt_choose_eventPhaseCSMeet',
        unit: '场',
        customkeyArrActJson: {
          phaseCode: {
            type: 'Array', //放到json里面字段值类型是数组
            isOnly: false, //是否去重
            keyArr: ['phaseCodes', 'phaseCode'], //[上传数据json对象里面的字段值，第一个元素里面存储的val值（从chooseItemArr里面取的字段名）]
          },
          //   delegationId: {
          //     type: 'Array', //放到json里面字段值类型是数组
          //     isOnly: false, //是否去重
          //     keyArr: ['organisationCodes', 'delegationId'], //[上传数据json对象里面的字段值，第一个元素里面存储的val值（从chooseItemArr里面取的字段名）]
          //   },
          //   dateYMD: {
          //     type: 'Array', //放到json里面字段值类型是字符串
          //     isThisObj: false, //是否是this中的对象，true为是；flase为不是
          //     keyArr: ['startDates', 'dateYMD'], //[上传数据json对象里面的字段值，第一个元素里面存储的val值（从chooseItemArr里面取的字段名）]
          //   },
        },
      },
      themeTemplateType: 38,
    }
  },
  created() {
    this.initPbPx()
    if (this.currGroup) {
      this.init()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    currBigSports() {
      let label = ''
      this.bigSportsList.forEach((item) => {
        if (item.id === this.curMatchLabelFixedIcon) {
          label = item.CN
        }
      })
      return {
        label: label,
        icon: this.curMatchLabelFixedIcon,
      }
    },
    // curMatchListNum() {
    //   let curMatchListNum = 0
    //   if (this.matchList && this.matchList.length > 0) {
    //     this.matchList.forEach((group) => {
    //       curMatchListNum +=
    //         group.list && group.list.length ? group.list.length : 0
    //     })
    //   } else {
    //     curMatchListNum = -1
    //   }
    //   console.debug('curMatchListNum:', curMatchListNum)
    //   return curMatchListNum
    // },
    noMore() {
      console.debug('noMore:', this.matchTotal, this.isScrollBottom)
      return this.matchTotal !== 0
    },
    noData() {
      return (
        this.matchTotal === 0 && this.matchList && this.matchList.length === 0
      )
    },
    tableHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375

      return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      // return 500
    },
  },
  methods: {
    async init() {
      this.selectOptData = JSON.parse(JSON.stringify(this.selectOptData_origin))
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.initMatchListQuery()
      console.debug(this.currCid, this.currSid)
      if (this.initFindanalysisItem && (!this.themeItem || !this.crossSeason)) {
        this.initFindanalysisItem()
      }
      await this.getSportsAndEventList()
      await this.getScheduleMatchList()
      this.computedSelectOpt(this.selectOptData.configArr)
      this.updateThemeItemObj()

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async selectOpt_manualRefresh() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getScheduleMatchList()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    scrollListenerEvent() {
      const scrollTop = this.scrollAreaDom.scrollTop
      const scrollHeight = this.scrollAreaDom.scrollHeight
      const parentHeightPx = this.scrollAreaDom.offsetHeight
      let direction = this.DIRECTION_ENUM.DOWN
      if (this.beforeScrollTop > scrollTop) {
        direction = this.DIRECTION_ENUM.UP
      }
      // 通过滚动方向判断是触底还是触顶
      // console.debug(
      //   'direction:',
      //   direction,
      //   scrollTop,
      //   parentHeightPx,
      //   scrollHeight,
      //   this.isScrollBottom,
      //   this.matchTotal
      // )
      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }
      // if (scrollTop > 0) {
      //   this.changeMatchLabelFixed(scrollTop, direction)
      // }

      this.scrollChangeHandler(scrollTop)

      if (direction == this.DIRECTION_ENUM.DOWN) {
        // 滚动触底
        if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
          console.debug('滚动触底')
          // this.load()
          if (this.pnum > this.allPages) {
            this.isScrollBottom = true
          }
        }
      } else {
        // 滚动到顶部
        this.isScrollBottom = false
        if (scrollTop <= this.threshold) {
          console.debug('滚动到顶部')
        }
      }
      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      console.debug(
        'this.parentWidthPx:',
        this.$refs.tableParentDom.scrollHeight
      )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })
      // this.scrollAreaDom = document.getElementsByClassName(
      //   `${this.scrollDomClassName}`
      // )[0]
      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      // console.debug(this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    changeChooseNumEventHandler(data) {
      if (data.init) {
        // 清除缓存，重新开始
        this.$localStorage.removeItem(
          data.localStorageName // this.multipleChoiceShareFixedBtn_modeType.localStorageName
        )
        this.matchList.forEach((group) => {
          group.list.forEach((item) => {
            item.isChooseFlag = false
          })
        })
      } else {
        const chooseSchedule = JSON.parse(
          this.$localStorage.getItem(
            data.localStorageName // this.multipleChoiceShareFixedBtn_modeType.localStorageName
          )
        )
        this.matchList.forEach((group) => {
          group.list.forEach((item) => {
            if (chooseSchedule.chooseIdArr.includes(item.chooseId)) {
              item.isChooseFlag = true
            } else {
              item.isChooseFlag = false
            }
          })
        })
        this.localStorageChooseList = chooseSchedule.chooseItemArr
      }
      this.smallBtnArr.forEach((item) => {
        if (item.type === 'check') {
          item.val = data.val
        }
      })
    },
    changeMatchLabelFixed(valPx, direction) {
      let scrollMatchItemHeightArr = this.scrollMatchItemHeightArr || []
      let curMatchLabelFixedIcon = null
      for (let i = 0; i < scrollMatchItemHeightArr.length; i++) {
        const item = scrollMatchItemHeightArr[i]
        if (item.heightPx > valPx && valPx <= item.heightPx) {
          if (item.heightPx - this.matchItemPbpx < valPx) {
            curMatchLabelFixedIcon = null
          } else {
            curMatchLabelFixedIcon = item.icon
          }
          break
        }
      }

      console.debug(
        'curMatchLabelFixed:',
        scrollMatchItemHeightArr,
        curMatchLabelFixedIcon,
        valPx,
        direction
      )
      if (this.matchTotal > 0) {
        this.curMatchLabelFixedIcon = curMatchLabelFixedIcon
      }
    },
    getScheduleMatchListDomHeigt() {
      let scrollMatchItemHeightArr = []
      let curHeightPx = 0
      const matchList = this.matchList
      matchList.forEach((item) => {
        let dom = document.getElementById(`matchList_${item.icon}`)
        curHeightPx += dom.offsetHeight //里面含paddingBottom值了
        scrollMatchItemHeightArr.push({
          icon: item.icon,
          heightPx: curHeightPx,
        })
      })
      this.curHeightPx = curHeightPx
      console.debug('getScheduleMatchListDomHeigt:', scrollMatchItemHeightArr)
      this.scrollMatchItemHeightArr = scrollMatchItemHeightArr
    },
    initPbPx() {
      this.matchItemPbpx = Math.ceil(2.78 * this.vw2px)
    },
    onResizeEvent() {
      this.initPbPx()
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        console.debug(
          'computedSelectOpt:',
          config.dataName,
          this[config.dataName],
          list,
          mix_id
        )
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          isFilterable: config.isFilterable ? config.isFilterable : false,
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'bigSports') {
            // let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
            this.currStageBigSports = valPathArr[1]
            this.bigSportsArr.forEach((sportItem, sportIndex) => {
              if (sportItem.value === this.currStageBigSports) {
                this.sportEventsArr = sportItem.children
                this.currStageSportEvents = this.sportEventsArr[0].value
                this.selectOptData.configArr[0].selectIndex = sportIndex
              }
            })
            this.computedSelectOpt(this.selectOptData.configArr)
            // console.debug(
            //   'bigSports bigSports:',
            //   this.selectOptData,
            //   this.bigSportsArr
            // )
          } else if (valPathArr[0] === 'sportEvents') {
            this.currStageSportEvents = valPathArr[1]
          } else {
          }
          // 筛选表格逻辑
          this.updateThemeItemObj()
          this.initMatchListQuery()
          this.getScheduleMatchList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    // load() {
    //   console.debug('load')
    //   if (this.pnum > this.allPages || this.loading) {
    //     return
    //   }
    //   this.loading = true
    //   this.getScheduleMatchList()
    // },
    initMatchListQuery() {
      // this.pnum = 1
      this.matchTotal = 0
      this.allPages = 1
      if (this.matchList) {
        this.matchList = []
      }
      this.matchLabelArr = []
    },
    updateThemeItemObj() {
      // 修改主题里面的字段
      if (this.themeItem) {
        this.themeItem.sportsId = this.currStageBigSports
        this.themeItem.eventId = this.currStageSportEvents
      }
    },
    async getSportsAndEventList() {
      let params = {
        sid: this.currSid,
      }
      await https_sportsList_eventList(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            this.bigSportsArr = res.data.map((sportItem) => {
              return {
                value: sportItem.disciplineCode,
                name: sportItem.disciplineName,
                children: sportItem.events.map((event) => {
                  return {
                    value: event.eventCode,
                    name: event.eventName,
                  }
                }),
              }
            })
            this.sportEventsArr = this.bigSportsArr[0].children
            this.currStageBigSports = this.bigSportsArr[0].value
            this.currStageSportEvents = this.sportEventsArr[0].value
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    computedMatchList(list) {
      console.debug('computedMatchList:', list)
      let matchLabelArr = []
      if (list && list.length > 0) {
        let matchList = this.matchList ? this.matchList : []
        let labelObj = {}
        list.forEach((item) => {
          // let curIndex = 0
          let newItem = {}
          newItem.matchTime = item.formatDate
          newItem.matchName = `${item.disciplineName}·${item.eventName}${item.phaseName}`
          newItem.isChina = item.cn
          newItem.phaseCode = item.phaseCode
          newItem.chooseId = item.phaseCode
          newItem.playeStringName =
            item.athletes && item.athletes.length > 0
              ? item.athletes.join('/')
              : item.organisationName
          newItem.sportsId = item.disciplineCode
          newItem.sportsName = item.disciplineName
          newItem.eventId = item.eventCode
          newItem.eventName = item.eventName
          newItem.formatTime = item.formatDate
          newItem.delegationName = item.organisationName
          newItem.delegationId = item.organisationCode
          newItem.isChooseFlag = false

          if (matchLabelArr && matchLabelArr.length === 0) {
            matchLabelArr.push(item.disciplineCode)
            labelObj = {
              label: item.disciplineName,
              icon: this.currStageBigSports,
              list: [],
            }
          }
          labelObj.list.push(newItem)
        })

        if (labelObj.list.length > 0) {
          let curIndex = matchLabelArr.indexOf(labelObj.icon)
          if (curIndex > -1) {
            // console.debug('labelObj end:', matchList, matchList[curIndex])
            if (
              matchList.length > 0 &&
              matchList[matchList.length - 1].icon === labelObj.icon
            ) {
              // 新加载的数据第一批中有上一个组数据，此时是替换
              matchList[matchList.length - 1] = labelObj
            } else {
              // 数组中并没有该区域数据，直接push
              matchList.push(labelObj)
            }
          } else {
            matchList.push(labelObj)
          }
        }
        this.matchList = JSON.parse(JSON.stringify(matchList))
        this.matchLabelArr = JSON.parse(JSON.stringify(matchLabelArr))
        console.debug(
          'computedMatchList end:',
          labelObj,
          matchList,
          matchLabelArr
        )
      }
    },
    async getScheduleMatchList() {
      let params = {
        cid: this.currCid,
        sid: this.currSid,
        sportsId: this.currStageBigSports
          ? this.currStageBigSports == 'all'
            ? ''
            : this.currStageBigSports
          : '',
        eventId: this.currStageSportEvents
          ? this.currStageSportEvents == 'all'
            ? ''
            : this.currStageSportEvents
          : '',
        timeZone: this.curTimeZoneItem.val,
      }
      console.debug(params)
      await https_eventPhase_list(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data && res.data && res.data.length > 0) {
              // if (res.data.analysisItems && res.data.analysisItems.length > 0) {
              //   const themeList = res.data.analysisItems.map((item) => {
              //     item.actJson = JSON.parse(item.json)
              //     return item
              //   })
              //   let themeItem = themeList[0] ? themeList[0] : null
              //   this.themeItem = {
              //     analysisItemId: themeItem.analysisItemId,
              //     competitionId: themeItem.competitionId,
              //     seasonId: themeItem.seasonId,
              //     disciplineId: themeItem.sportsId ? themeItem.sportsId : 0,
              //     eventId: themeItem.eventId ? themeItem.eventId : 0,
              //     phaseId: themeItem.phaseId ? themeItem.phaseId : 0,
              //     matchId: 0, //马拉松赛事没有赛季概念，赛季其实就是比赛id
              //     analysisType: themeItem.analysisType,
              //     groupType: themeItem.groupType ? themeItem.groupType : 0,
              //     actJson: themeItem.actJson,
              //     json: themeItem.json,
              //     seasonOrMatch: themeItem.seasonOrMatch,
              //     analysisItemName: themeItem.analysisItemName
              //       ? themeItem.analysisItemName
              //       : '',
              //     dataImg: themeItem.dataImg ? themeItem.dataImg : '',
              //     useScene: themeItem.useScene ? themeItem.useScene : '',
              //   }
              // }
              this.matchTotal = res.data.length
              this.allPages = 1
              if (this.scrollAreaDom) {
                this.scrollAreaDom.scrollTo(0, 0)
              }
              this.matchList = []
              this.matchLabelArr = []
              this.curMatchLabelFixedIcon = null
              this.initScroll()
              this.computedMatchList(res.data)
              this.$nextTick(() => {
                this.getScheduleMatchListDomHeigt()
              })
            } else {
              console.debug('暂无数据')
              this.matchTotal = 0
              this.matchList = []
            }
            console.debug('暂无数据:', this.matchTotal, this.matchList)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
          this.isClearlearLocalStorageChoose()
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_schedule {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 2.778vw 0 6.964vw;
    &.multipleChoiceShare_fixedBtn_isCircular {
    }
    .tableScrollArea {
      position: relative;
      .match_label_fixed {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 3.472vw;
        background-color: var(--mixtmt_whiteColor);
        .match_label {
          width: 100%;
          height: 3.472vw;
          background-image: var(--mixtmt_scheduleMatchList_dateBg);
          background-size: 100% auto;
          background-position: left top;
          background-repeat: no-repeat;

          .label_textArea {
            position: absolute;
            left: 0;
            top: 50%;
            z-index: 2;
            transform: translateY(-50%);
            width: 21.55%;
            font-size: 1.38vw;
            color: var(--mixtmt_whiteColor);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .labelIcon {
              width: 2.778vw;
              height: 2.778vw;
              border: 1.5px solid var(--mixtmt_whiteColor);
              border-radius: 50%;
              overflow: hidden;
              margin-right: 0.694vw;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            & .letterSpa {
              letter-spacing: 0.4vw;
            }
          }
        }
      }
      /* .scrollDomContain {
            max-height: calc(100vh - 19.142vw);
            overflow: auto;
          } */
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
</style>
